import { Modal, ModalProps } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC } from 'react';
import * as Styles from './modals-new.module.less';

export interface PortalModalNewProps extends ModalProps {
    mobile?: boolean;
}

export const PortalModalNew: FC<PortalModalNewProps> = props => {
    const { mobile, ...otherProps } = props;
    return (
        <Modal
            closable
            {...otherProps}
            className={classNames(Styles.modal, { [Styles.modalMobile]: mobile }, props.className)}
            contentClassName={classNames(Styles.modalContent, props.contentClassName)}
            size={props.size ?? Modal.Sizes.M}
        >
            {props.children}
        </Modal>
    );
};
